export default function ListScreenTemplate(data) {
    //language=HTML
    return `
        <div class="tabs k-content n-text-right">

            <div class="bg-warning px-md-1 px-0 py-1 list-view-title">
                <div class="container-fluid">
                    <div class=" mb-2 mb-md-0 text-center ">
                        <h5 class=" mb-0">${data.entityType}</h5>
                    </div>
                </div>
            </div>


            <div id="splitter">
                <div class="tabs">
                    <div class=" info ">
                        <div class="container-fluid px-1">
                            <div class="details toolbar px-md-1 px-0 pb-2">
                                <div class="row quick-icons justify-content-between align-items-center position-relative pt-2 w-100 m-0 list-screen-toolbar">
                                    <div class="col-xl-5 col-lg-8 col-md-8 col-9 px-0">
                                        <ul class=" navbar-nav flex-row px-0 overflow-auto pb-2">
                                            <li>
                                                <a id="newRecord" role="button" class=" text-secondary" data-business-func="newRecord"><i
                                                        class="fa-solid fa-circle-plus"></i></a>
                                            </li>
                                            <li>
                                                <a id="listView" role="button" class=" text-secondary" data-business-func="listView"><i
                                                        class="fa-solid fa-clipboard-list"></i></a>
                                            </li>
                                            <li>
                                                <a id="printBtn" role="button" class=" text-secondary" data-business-func="print"><i
                                                        class="fa-solid fa-print"></i></a>
                                            </li>
                                            <li>
                                                <a id="export" role="button" class="btn-printing text-secondary" data-business-func="printAs">
                                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
                                                        <g>
                                                            <path fill="currentColor" class="st0" d="M150.1,103.3c0,5.4-4,9.4-9.5,9.4c-6.1,0-12.3,0-18.6,0c0,0.6,0,1.1,0,1.6c0,8.8,0,17.6,0,26.4
                                                                c0,5.5-4,9.5-9.5,9.5c-24.9,0-49.8,0-74.7,0c-5.5,0-9.5-4-9.5-9.5c0-8.9,0-17.8,0-26.7c0-0.4,0-0.8,0-1.4c-6.3,0-12.5,0-18.6,0
                                                                c-4.7,0-8.4-2.9-9.4-7.5c-0.1-0.6-0.2-1.3-0.2-1.9c0-18.7,0-37.4,0-56.1c0-5.6,4-9.6,9.6-9.6c43.7,0,87.4,0,131.1,0
                                                                c5.2,0,9.3,4.1,9.3,9.2C150.1,65.7,150.1,84.5,150.1,103.3z M112.5,84.6c-24.9,0-49.8,0-74.7,0c0,18.7,0,37.4,0,56
                                                                c25,0,49.8,0,74.7,0C112.5,121.9,112.5,103.3,112.5,84.6z M131.4,47.1c-5.2,0-9.4,4.2-9.4,9.4c0,5,4.2,9.2,9.2,9.3
                                                                c5.2,0,9.4-4.1,9.5-9.3C140.7,51.3,136.5,47.1,131.4,47.1z M70,90.8c3.1,0,6.1,0,9.2,0c0,7.2,0,12.7,0,17.8c5.1,0,10.6,0,17.8,0
                                                                c0,3.1,0,6.1,0,9.2c-7.2,0-12.7,0-17.8,0c0,5.1,0,10.6,0,17.8c-3.1,0-6.1,0-9.2,0c0-7.2,0-12.7,0-17.8c-5.1,0-10.6,0-17.8,0
                                                                c0-3.1,0-6.1,0-9.2c7.2,0,12.7,0,17.8,0C70,103.5,70,98,70,90.8z M112.6,28.2c0-6.2,0-12.4,0-18.6c-25,0-49.9,0-74.9,0
                                                                c0,6.2,0,12.3,0,18.6c-3.2,0-6.2,0-9.4,0c0-0.4-0.1-0.8-0.1-1.3c0-5.8,0-11.7,0-17.6c0-5.1,4.1-9.2,9.2-9.2c25.1,0,50.2,0,75.3,0
                                                                c5.2,0,9.2,4.1,9.2,9.3c0,6.2,0,12.4,0,18.7C118.8,28.2,115.8,28.2,112.6,28.2z"/>
                                                        </g>
                                                    </svg>
                                                </a>
                                            </li>
                                            <li>
                                                <a id="reviseBtn" role="button" class=" text-secondary" data-business-func="revise"><i
                                                        class="fa-solid fa-file-circle-check"></i></a>
                                            </li>
                                            <li>
                                                <a id="unReviseBtn" role="button" class=" text-light" data-business-func="unrevise"><i
                                                        class="fa-solid fa-file-circle-xmark"></i></a>
                                            </li>
                                            <li>
                                                <a id="toggleFilterAndSort" role="button" class=" text-secondary filter"
                                                   data-business-func="filterAndSort"><i
                                                        class="fa-solid fa-filter"></i></a>
                                            </li>
                                            <li>
                                                <a id="treeViewBtn" role="button" class="tree-view-btn text-secondary"
                                                   data-business-func="treeView"><i class="fa-solid fa-tree"></i></a>
                                            </li>
                                            <li>
                                                <a id="showResultSettings" role="button" class="text-secondary"
                                                   data-business-func="resultSettings"><i class="fa-solid fa-table-list"></i></a>
                                            </li>
                                            <li>
                                                <a id="exportcsv" role="button" class=" text-secondary" data-business-func="exportAsXLSX"><i
                                                        class="fa-solid fa-file-excel"></i></a>
                                            </li>
                                            <li>
                                                <a id="deleteBtn" role="button" class=" text-secondary" data-business-func="delete"><i
                                                        class="fa-solid fa-trash-can"></i></a>
                                            </li>
                                            <li>
                                                <a id="autoFitCols" role="button" class=" text-secondary" data-business-func="autoFitCols"><i
                                                        class="fa-solid fa-sliders"></i></a>
                                            </li>
                                            <li>
                                                <a id="refreshBtn" role="button" class=" text-secondary" data-business-func="refresh"><i
                                                        class="fa-solid fa-arrow-rotate-right"></i></a>
                                            </li>
                                            <li>
                                                <a id="listViewName" role="button" class=" text-secondary" data-business-func="listViewName"><i
                                                        class="fa-solid fa-display"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-md-4 col-3 px-md-0 n-text-left pl-0">
                                        <div class=" d-flex justify-content-end align-items-center pb-2">
                                            <a id="homeBtn" role="button" class=" text-secondary" data-business-func="homePage"><i
                                                    class="fa-solid fa-home"></i></a>
                                            <div class="line-h"></div>
                                            <a id="moreMenu" role="button" class=" text-secondary"><i class="fa-solid fa-bars"></i></a>
                                        </div>
                                    </div>
                                </div>

                                <div class="b-filter pt-1 list-view-criteria criteriaRoot">

                                    <div class="row w-100 mx-auto mb-1 align-items-center pt-1 ">
                                        <div class="col-lg-3 col-md-6">
                                            <select id="sortOn" class="w-100 test col-lg-12" multiple="multiple"></select>
                                        </div>
                                        <div class="col-lg-3 col-md-6">
                                            <div class="row w-100 mx-auto mb-1 justify-content-between">
                                                <div class="col-6" id="ascDescGroup">
                                                </div>
                                                <div class="col-6 justify-content-md-between justify-content-end" id="conditionsGroup">
                                                </div>
                                            </div>
                                        </div>
                                        <div id="extraCriteriaContainer" class="col-lg-5 col-md-9">
                                            <div class=" widgetContainer"></div>
                                        </div>
                                        <div class="col-lg-1 col-md-3">
                                            <div class="check-search">
                                                <input id="showSearch" class=" k-checkbox k-checkbox-md" type="checkbox"/>
                                                <label class=" mb-0" for="showSearch">
                                                    <span>${data.translateId("showFilter")}</span>
                                                    <i class="fa-solid fa-thumbtack text-secondary" title="Pin"></i>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="gridAllVoice"></div>
                            </div>

                        </div>
                    </div>
                </div>
                <div id="paneTreeView" class="n-text-right py-3">
                    <div id="treeview-kendo"></div>
                    <div class="k-close-treeview-mobile"></div>
                </div>
            </div>
        </div>`;
}